module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"clappr","commonjs":"clappr","commonjs2":"clappr","root":"Clappr"}
// module id = 1
// module chunks = 0